// extracted by mini-css-extract-plugin
module.exports = {"red":"team_red_2RzGm"};